import { useState, useEffect, useCallback } from 'react';
import type { UserPreferences, UpdatePreferencesDto } from '@reqshare/shared';
import { DEFAULT_PREFERENCES } from '@reqshare/shared';
import { getProfile, updatePreferences } from '../api/auth-api';

const JWT_KEY = 'reqshare_jwt';

export function useWebSettings() {
  const [preferences, setPreferences] = useState<UserPreferences>(DEFAULT_PREFERENCES);
  const [loading, setLoading] = useState(true);

  const loadPreferences = useCallback(async () => {
    const token = localStorage.getItem(JWT_KEY);
    if (!token) {
      setLoading(false);
      return;
    }

    try {
      const profile = await getProfile(token);
      setPreferences(profile.preferences);
    } catch {
      // Use defaults if fetch fails
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadPreferences();
  }, [loadPreferences]);

  const update = useCallback(async (dto: UpdatePreferencesDto) => {
    const token = localStorage.getItem(JWT_KEY);
    if (!token) return;

    try {
      const updated = await updatePreferences(dto, token);
      setPreferences(updated);
    } catch (err) {
      console.error('Failed to update preferences:', err);
    }
  }, []);

  return { preferences, updatePreferences: update, loading, reload: loadPreferences };
}
